<app-navbar></app-navbar>

<!-- Content -->
<ng-content></ng-content>

<app-footer></app-footer>
